/**
 * PartnerRegisterPage — iter253 REDIRECT SHIM.
 *
 * Standalone partner self-registration is deprecated. A "Partner" must
 * now be the tail-end of the verified CARTAL Business flow:
 *   /join → business registration → admin verification → visible partner.
 *
 * This shim exists only so that (a) any deep link or cached search
 * result pointing at /partner/register does not 404 in production, and
 * (b) users landing here are redirected to the unified /join chooser
 * without losing the activity category if the caller passed one via
 * `?activity=...`.
 */
import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function PartnerRegisterPage() {
  const location = useLocation();
  useEffect(() => {
    // no-op: <Navigate> below handles the redirect. Kept as a hook so a
    // future revision can log the deprecation without extra churn.
  }, [location.pathname]);

  const qs = new URLSearchParams(location.search);
  const activity = qs.get("activity") || "";
  const target = `/join?intent=partner${activity ? `&activity=${encodeURIComponent(activity)}` : ""}`;
  return <Navigate to={target} replace />;
}
